import { createSelector } from 'reselect';
import browserUtils from '@common/utils/browserUtils';

const getApp = (state) => state.app;

const AppSelectors = {
  makeBrand: createSelector([getApp], (app) => app.brand),
  makeBaseUrl: createSelector([getApp], (app) => app.baseUrl),
  makeCookieEnabledServices: createSelector([getApp], (app) => app.cookieEnabledServices),
  makeclusterSettings: createSelector([getApp], (app) => app.clusterSettings),
  makeEncodedGuidZuid: createSelector([getApp], (app) => app.encodedGuidZuid),
  makeHostname: createSelector([getApp], (app) => app.hostname),
  makePrevPath: createSelector([getApp], (app) => app.prevPath),
  makeIsScreenMobile: createSelector([getApp], (app) => {
    const screenType = browserUtils.screen.type(app.screenSize);
    return screenType === browserUtils.screenType.MOBILE;
  }),
};

export default AppSelectors;
